import gql from "graphql-tag";

const GET_9141C_FORM_DATA = gql`
  query getForm9141CById($id: String!) {
    getForm9141CById(id: $id) {
      formVersionId
      payload {
        visaType
        requestorPocLastName
        requestorPocFirstName
        requestorPocMiddleName
        requestorPocJobTitle
        requestorPocAddr1
        requestorPocAddr2
        requestorPocCity
        requestorPocState
        requestorPocPostalCode
        requestorPocCountry
        requestorPocProvince
        requestorPocPhone
        requestorPocPhoneExt
        requestorPocEmail
        empBusinessName
        empTradeName
        empAddr1
        empAddr2
        empCity
        empState
        empPostcode
        empCountry
        empProvince
        empPhone
        empPhoneext
        empFein
        empNaics
        empNaicsDesc
        attyRepresentType
        attyLastname
        attyFirstname
        attyMiddlename
        attyAddr1
        attyAddr2
        attyCity
        attyState
        attyPostcode
        attyCountry
        attyProvince
        attyPhone
        attyPhoneext
        attyEmail
        attyBizname
        attyFein
        jobTitle
        suggestedSocCode
        suggestedSocTitle
        supervisorJobTitle
        superviseOtherEmp
        superviseHowMany
        supervisionLevelSub
        supervisionLevelPeer
        jobDuties
        travelRequired
        travelDetails
        primaryEducationLevel
        major
        otherEducation
        secondDiploma
        secondDiplomaMajor
        trainingRequired
        numberOfMonthsTraining
        nameRequiredTraining
        empExperienceRequired
        empExperienceMonths
        occupationRequired
        specialRequirements
        primaryWorksiteAddr1
        primaryWorksiteAddr2
        primaryWorksiteCity
        primaryWorksiteState
        primaryWorksitePostalCode
        otherWorksiteLocation

        otherWorksites {
          worksiteAddr1
          worksiteAddr2
          worksiteCity
          worksitePostalCode
          worksiteState
          worksiteCountyTownship {
            value
            label
          }
          worksiteBlsAreaId
          error
        }
      }
    }
  }
`;

const SUBMIT_9141C_FORM = gql`
  mutation SubmitForm9141C(
    $id: String!
    $Form9141CFormData: Form9141CFormData!
    $token: String
  ) {
    SubmitForm9141C(
      Form9141CFormData: $Form9141CFormData
      id: $id
      token: $token
    )
  }
`;

const UPDATE_9141C_FORM = gql`
  mutation updateForm9141CById(
    $id: String!
    $Form9141CFormData: Form9141CFormData!
    $formUI9141C: formUIInput
    $profilePrefillMetadata: [ProfilePrefillMetadataInput!]
  ) {
    updateForm9141CById(
      id: $id
      Form9141CFormData: $Form9141CFormData
      formUI9141C: $formUI9141C
      profilePrefillMetadata: $profilePrefillMetadata
    )
  }
`;

const GET_9141C_PROFILES = gql`
  query {
    getUserProfileInfo {
      EmployerProfiles {
        employer_id
        employer_name
      }
      EmployerPOCProfiles {
        employer_poc_id
        employer_poc_name
      }
      AgentIndividualProfiles {
        agent_ind_id
        agent_ind_name
      }
    }
  }
`;

export {
  GET_9141C_FORM_DATA,
  UPDATE_9141C_FORM,
  SUBMIT_9141C_FORM,
  GET_9141C_PROFILES,
};
